/**
 * Vendor
 */
import React, { Suspense, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

/**
 * Initialize day.js for date/time operations
 * Replaces moment.js with day.js
 */
import './lib/dayjs-config';

/**
 * App
 */
import "./i18n";
import SportsbookModule from './mfe/SportsbookModule';
import reportWebVitals from './reportWebVitals';

/**
 * Swiper CSS - Import before App.scss to allow overrides
 */
import 'swiper/swiper-bundle.css';

/**
 * CUSTOM STYLE
 */
import './App.scss';

function StandaloneEntry() {
  useEffect(() => {
    // Make standalone root land on the module base route.
    if (window.location.pathname === '/') {
      window.history.replaceState({}, '', '/sports');
    }
  }, []);

  return <SportsbookModule />;
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter basename="/">
    <Suspense fallback={<div></div>}>
      <StandaloneEntry />
    </Suspense>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
